import { createNewEvent } from "./createNewEvent";
import { createPasscode } from "./createPasscode";
import { eventCreateTrainingType } from "./eventCreateTrainingType";
import { eventMyDrafts } from "./eventMyDrafts";
import { eventPublishedByMe } from "./eventPublishedByMe";
import { eventPublishedByOthers } from "./eventPublishedByOthers";
import { colors } from "../../stripeColors";
import { FormattedMessage } from "react-intl";


export let events = {
  name: <FormattedMessage id="MANAGE_VQVT" />,
  path: (tenantName) => `/${tenantName}/events`,
  buttons: (navigate, tenantName) => [
    // {
    //   key: 1,
    //   label: eventCreateTrainingType.label,
    //   path: eventCreateTrainingType.path(tenantName),
    //   icon: eventCreateTrainingType.icon,
    //   onClick: () => navigate(eventCreateTrainingType.path(tenantName)), 
    // },
    {
      key: 1,
      label: createNewEvent.label,
      path: createNewEvent.path(null, null, tenantName),
      icon: createNewEvent.icon,
      onClick: () => navigate(createNewEvent.path(null, null, tenantName)), 
    },
    {
      key: 2,
      label: createPasscode.label,
      path: createPasscode.path(tenantName),
      icon: createPasscode.icon,
      onClick: () => navigate(createPasscode.path(tenantName)), 
    },
  ],
  tiles: (navigate, tenantName, val1, val2, val3,) => [
    {
      key: 1,
      label: eventMyDrafts.label,
      path: eventMyDrafts.path(tenantName),
      value: val1,
      color: colors.blue,
      onClick: () => navigate(eventMyDrafts.path(tenantName)),
    },
    {
      key: 2,
      label: eventPublishedByMe.label,
      path: eventPublishedByMe.path(tenantName),
      value: val2,
      color: colors.purple,
      onClick: () => navigate(eventPublishedByMe.path(tenantName)),
    },
    {
      key: 3,
      label: eventPublishedByOthers.label,
      path: eventPublishedByOthers.path(tenantName),
      value: val3,
      color: colors.red,
      onClick: () => navigate(eventPublishedByOthers.path(tenantName)),
    },
  ],
};
